module.exports = __webpack_public_path__ + "imgs/evelyn-lachapelle.e4fca58890f2e26b6c187b7576efbd46.jpg";